export default __webpack_public_path__ + "static/kiwoom_securities-d8e0dab05818d2fa8c898199fce00f16.png";